import { createClient, processLock } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    '[Supabase] Faltan VITE_SUPABASE_URL o VITE_SUPABASE_ANON_KEY en el entorno. ' +
    'Añádelos al archivo .env.local para activar la autenticación.'
  )
}

export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      // Por defecto usa navigator.locks (Navigator LockManager) para
      // coordinar el refresco del token entre pestañas — en WebViews de
      // Android (y algunos navegadores) esa API puede quedarse bloqueada
      // y el error "Acquiring an exclusive Navigator LockManager lock...
      // timed out" se cuela sin capturar hasta la UI (visto en producción
      // 2026-08-07). processLock es la alternativa oficial de Supabase
      // para estos casos: coordina solo dentro de la misma pestaña, sin
      // usar la API del navegador — se pierde la coordinación entre
      // pestañas (poco relevante aquí) a cambio de no depender de una API
      // que falla en según qué WebView.
      lock: processLock,
    },
  }
)
